import { Component } from '@angular/core';

import { KeycloakService } from '../../services/keycloak.service';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'help-cmp',
  templateUrl: 'help.html',

  imports: [CommonModule],
})
export class HelpComponent {
  isFarmer: boolean;

  public constructor() {
    const roles: string[] = KeycloakService.auth.authz.tokenParsed.realm_access.roles;
    this.isFarmer = roles.length === 1 && roles[0] === 'ROLE_FARMER';
  }
}
